import { IKImage } from "imagekitio-react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom'
import { getLeads } from "../../../redux/actions/userSubscription";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import ReactPixel from "react-facebook-pixel"
const CoinCard = ({
  isDiscount,
  id,
  product_name,
  cost,
  url,
  isCardEnabled,
  setIsCardEnabled,
  cardData,
  razorpayHandler,
}) => {

  const user_id = useSelector(store => store?.profileDetails?.id)
  const user_plan = useSelector(store => store?.userSubscription?.role_type ? store?.userSubscription?.role_type : 'basic')
  const discountData = useSelector((store)=> store?.userDiscount?.discount)
  const authentication = useSelector(store=>store?.authentication);
  const navigate = useNavigate()
  const location = useLocation();
  const dispatch = useDispatch()
  const email = useSelector(store => store?.profileDetails?.email)
  const [pricingSpinner, setPricingSpinner] = useState(false);


  function toggleBackgroundColor(isCardEnabled) {
    if (isCardEnabled) {
      if (id === 2)
        return "md:ml-1 md:mr-1 mb-10 md:mb-2 md:w-72  lg:mr-5 lg:ml-5 bg-pricing_blue flex flex-col border-4 border-amber-300 md:border-amber-400 rounded-2xl  items-center cursor-pointer";
      else
        return "md:ml-1 md:mr-1 mb-10 md:mb-2  md:w-72 lg:mr-5 lg:ml-5 bg-pricing_blue flex flex-col border-2 border-gray-300 md:border-gray-200 rounded-2xl  items-center cursor-pointer";
    } else {
      if (id === 2)
        return " md:ml-1 md:mr-1 mb-10 md:mb-2  md:w-72 lg:mr-5 lg:ml-5 bg-white flex flex-col border-4 border-amber-300 md:border-amber-400 rounded-2xl  items-center cursor-pointer";
      else
        return " md:ml-1 md:mr-1 mb-10  md:mb-2  md:w-72 lg:mr-5 lg:ml-5 bg-white flex flex-col border-2 border-gray-300 md:border-gray-200 rounded-2xl  items-center cursor-pointer";
    }
  }

  return (
    <div
      className={toggleBackgroundColor(isCardEnabled)}
      onClick={(event) => setIsCardEnabled(id)}
    >
      {id === 2 && (
        <>
          <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src={
              "https://assets.learntube.ai/files/PRICING/img4.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658852702613"
            }
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
            className="-mt-4"
          />
          <p className="-mt-8 text-sm font-bold text-white md:-mt-7 ">
            MOST PURCHASED
          </p>
        </>
      )}
      {id === 3 && (
        <div className="-mt-6 h-10 w-3/5 rounded-2xl bg-cyan-400 pt-2 text-center font-bold text-white">
          BEST VALUE
        </div>
      )}
      {id === 3 && (
        <img
          urlEndpoint="https://assets.learntube.ai/files/"
          src={url}
          transformation={[
            {
              height: "160",
              width: "160",
            },
          ]}
          className="mt-2 mb-2 h-20 w-4/5"
        />
      )}
      {id === 2 && (
        <img
          urlEndpoint="https://assets.learntube.ai/files/"
          src={url}
          transformation={[
            {
              height: "160",
              width: "160",
            },
          ]}
          className="mt-5 mb-2 h-20 w-4/5"
        />
      )}{" "}
      {id === 1 && (
        <img
          urlEndpoint="https://assets.learntube.ai/files/"
          src={url}
          transformation={[
            {
              height: "160",
              width: "160",
            },
          ]}
          className="mt-5 mb-3 h-20 w-4/5"
        />
      )}
      <h1 className={isCardEnabled ? "mb-3 text-white " : "mb-3  text-base"}>
        {product_name}
      </h1>
      <div
        className={`${isCardEnabled ? "mb-6  text-3xl text-white" : "mb-6 text-3xl"} flex flex-col justify-between items-center`}
      >
       { (discountData === undefined  ||  isDiscount === false || authentication=== null )? 
             <>
             <h1>₹{cost}</h1>
             <small className="text-lg text-red-500 font-medium line-through">₹{cardData?.pp_original_cost}</small>
             </> : 
             <>
             <h1>₹{Math.ceil(cost - ((cost*(discountData)/200)))}</h1>
              <small className="text-lg text-red-500 font-medium line-through">₹{cost}</small>
             </>
        }
      </div>
      <button
        value={cardData?.id}
        className="flex justify-center items-center py-3 w-10/12 rounded-3xl bg-gradient-to-r from-amber-400 to-amber-600 text-center text-sm font-bold text-white shadow-xl md:mb-2"
        onClick={(e) => {
          if (user_id) {
            setPricingSpinner(true);
            Mixpanel.track(Constants.Mixpanel.PAYMENT_ATTEMPT , {
              distinct_id: email,
            });
            ReactPixel.trackSingle("333999584825866", "Attempt_to_pay")
            dispatch(getLeads({ user_id, user_plan, product_id: cardData?.id, product_name, product_type: 'coin', is_visit: false }))
            razorpayHandler(cardData?.id, () => {
              setPricingSpinner(false);
            })
          }
          else {
            navigate("/login", { state: { from: location } })
          }
        }}
      >
        {
          pricingSpinner === true ? <div className="w-8 h-8 rounded-full border-4 border-white border-t-transparent animate-spin">
          </div> :
            'Buy Bundle'
        }
      </button>
      <div className="mb-2"></div>
    </div>
  );
};

export default CoinCard;
